// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"8ec6b393","276":"0bd9306a","564":"ec940580","756":"1b77460a"}[chunkId] + ".chunk.js";
};